import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {DataConfig} from '../../../shared/models/tabs-data';
import {Observable, Subscription} from 'rxjs';
import {NetworkSettings} from '../../../shared/models/network-settings';
import {FormGroup} from '@angular/forms';
import {WifiFormLogicService} from '../../../shared/services/wifi-form-logic.service';
import {SiteGetInfoService} from '../../services/site-get-info.service';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {UpdateDynamicFormService} from '../../../shared/services/update-dynamic-form.service';

@Component({
  selector: 'storever-network-edit',
  templateUrl: './network-edit.component.html',
  styleUrls: ['./network-edit.component.scss']
})
export class NetworkEditComponent implements OnInit, OnDestroy {

  dataConfig: DataConfig;
  content: Observable<NetworkSettings>;
  @Output() saveForm = new EventEmitter<Object>();
  private sub$: Subscription;
  private subscriptions = [];
  private form: FormGroup;
  private isVideo = true;
  private isLoadingWifi = false;

  constructor(private wifiFormLogicService: WifiFormLogicService,
              private updateDynamicFormService: UpdateDynamicFormService,
              private siteGetInfoService: SiteGetInfoService) {}

  ngOnInit(): void {
    this.wifiFormLogicService.videoStatus(this.isVideo);
    this.dataConfig.form.disable();
    this.content = this.dataConfig.content;
    this.content.subscribe(sub => {
      this.form = this.dataConfig.form;
      // network
      this.wifiFormLogicService.isDhcpValueChange(this.dataConfig.form, [ 'ipAddress']);
      this.wifiFormLogicService.isWifiEnabledChange(this.dataConfig.form, ['wifi']);
      this.wifiFormLogicService.setMandatoryProxy(this.form, [ 'proxy']);
      this.setMandatory(this.form);
      this.wifiFormLogicService.wifiToggleElemInit(this.form , this.isLoadingWifi);
      this.dataConfig.form.patchValue(sub);
      // end network
    });
    this.checkWifiValueChange();
  }

  ngOnDestroy(): void {
    this.dataConfig.form.markAsPristine();

    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    if (this.wifiFormLogicService.SubscriptionList.length) {
      this.wifiFormLogicService.SubscriptionList.forEach(sub => sub.unsubscribe());
    }
  }

  setMandatory(form: FormGroup): void { // TODO: move to parent order-detail
    this.wifiFormLogicService.validatorWifi(form );
    this.wifiFormLogicService.setMandatoryProxy(form, ['proxy']);
    this.wifiFormLogicService.validatorWifiSecurity(form );
    this.wifiFormLogicService.validatorWifiEap(form );
    this.checkWifiValueChange();
  }

  /**
   * - getRawValue from FormGroup even if disabled
   * - Update/patch part of the order
   * @param apiName
   */
  save(apiName: string[]): void {
    const resp = this.dataConfig.form.value;
    this.saveForm.emit({api: apiName, data: resp});
  }

  undo(formPath: string[]): void {
    this.dataConfig.form.get(formPath).reset();
    this.dataConfigContentPatchForm(formPath);
  }

  dataConfigContentPatchForm(formPath?: string[]): void {
    this.content = this.dataConfig.content;
    this.sub$ = this.content.subscribe(sub => {
      if (formPath) {
        this.dataConfig.form.get(formPath).patchValue(sub[formPath[0]]);
      } else {
        this.dataConfig.form.patchValue(sub);
      }
    });
    this.subscriptions.push(this.sub$);
  }

  isOrderOpened(): Observable<boolean> {
    return this.siteGetInfoService.isOrderOpened()
  }
  isServiceVideo(): Observable<boolean> {
    return this.siteGetInfoService.isServiceVideo()
  }

  get isStatusOff$(): Observable<boolean> {
    return this.siteGetInfoService.isStatusOff()
  }

  updateWarningSSID(ssid: string): void {
    if (this.containsWhitespace(ssid[0]) || this.containsWhitespace(ssid[ssid.length - 1]) ) {
      this.updateDynamicFormService.updateElement('ssid', true, 'warning');
    } else if ((!this.containsWhitespace(ssid[0]) && !this.containsWhitespace(ssid[ssid.length - 1]))) {
      this.updateDynamicFormService.updateElement('ssid', false, 'warning');
    }
  }
  updateWarningPassword(password: string): void {
    this.updateDynamicFormService.updateElement('security_password', true, 'warning');
    if (this.containsWhitespace(password[0]) || this.containsWhitespace(password[password.length - 1]) ) {
      this.updateDynamicFormService.updateElement('security_password', true, 'warning');
    } else if (!this.containsWhitespace(password[0]) && !this.containsWhitespace(password[password.length - 1])) {
      this.updateDynamicFormService.updateElement('security_password', false, 'warning');
    }
  }
  containsWhitespace(str: string): boolean {
    return /\s/.test(str);
  }

  checkWifiValueChange(): void {
    this.sub$ = this.dataConfig.form.get('wifi').valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(200),
    ).subscribe(value => {
      if (value) {
        if (value.security_password) {
          this.updateWarningPassword(value.security_password);
        } else {
          this.updateDynamicFormService.updateElement('updateWarningPassword', false, 'warning');
        }
        if (value.ssid) {
          this.updateWarningSSID(value.ssid);
        } else {
          this.updateDynamicFormService.updateElement('ssid', false, 'warning');
        }
      }
    })
  }
}
